<template>
	<div class="menu-container" :style="menuStyle">
		<div class="menu-banner menuOnly" :class="{heatmapOpacity: menusStore.heatMap}">
			<img class="image-multi-menu" :class="{hidden: hiddenMultiMenu, hiding: hidingMultiMenu, bigger: startAnimation}" :src="bannerPicture" :alt="getString('menu_banner')">
			<img class="image-menu" :class="{hidden: hiddenMenu, hiding: hidingMenu, opaque: startAnimation}" :src="imageMenu" :alt="getString('menu_banner')">
		</div>
		<div class="menu-container-scroll" ref="menu-container-scroll" id="menu-container-scroll">
			<ReservationsTopBar />
			<BannerRoundedCorners />
			<div class="menu-container-scroll-content">
				<MenuHeader />
				<ReservationsBody />
				<MenuFooter />
			</div>
		</div>
	</div>
</template>

<script>
import MenuBody from "@/new-menu/components/MenuBody.vue";
import MenuFooter from "@/new-menu/components/MenuFooter.vue";
import MenuHeader from "@/new-menu/components/MenuHeader.vue";
import BannerRoundedCorners from "@/new-menu/components/BannerRoundedCorners.vue";
import {useEvsStore, useMenusStore} from "@/new-menu/stores";
import MenuTextInput from "@/new-menu/components/generic/MenuTextInput.vue";
import {useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {isTextColorDark} from "@/shared/helpers/ui";
import ReservationsTopBar from "@/book/components/ReservationsTopBar.vue";
import ReservationsBody from "@/book/components/ReservationsBody.vue";
import {useReservationsStore} from "@/book/stores";

export default {
	setup() {
		let menusStore = useMenusStore();
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		const reservationsStore = useReservationsStore();
		let svgStore = useSvgStore();
		let evsStore = useEvsStore();
		return {menusStore, getString: languageStore.getString, notificationStore, reservationsStore, getIcon: svgStore.get, evsStore}
	},
	name: "MenuView",
	mixins: [WindowWidth],
	components: {ReservationsBody, ReservationsTopBar, MenuTextInput, BannerRoundedCorners, MenuHeader, MenuFooter, MenuBody},
	data() {
		return {
			currentScroll: 0,
			minScroll: this.menusStore.imageSize - 65,
			maxScroll: this.menusStore.imageSize - 25,
			hiddenMultiMenu: false,
			hidingMultiMenu: false,
			hiddenMenu: true,
			hidingMenu: true,
			startAnimation: true,
			cartButtonExplosion: false,
		}
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else {
				return "550px";
			}
		},
		menuStyle() {
			let bg1 = this.menusStore.theme.bg_1;
			let isLight = this.menusStore.theme.light;
			let imageSize = this.menusStore.imageSize;
			let scrollPercentage = this.getPercentScroll();
			let alphaHex50 = this.alphaToHex(scrollPercentage*0.5);
			let alphaHex20 = this.alphaToHex(scrollPercentage*0.2);
			let themeBg1Animated = "--theme-bg1-color-animated: #" + bg1 + alphaHex50 + ";";
			let blurAnimated = "--blur-animated: " + (scrollPercentage * 6) + "px;";
			let boxShadowColor = "--theme-dark-animated: #000000" + (isLight ? alphaHex20 : alphaHex50) + ";";
			let opacityAnimated = "--opacity-animated: " + scrollPercentage + ";";
			let opacityAnimatedReverse = "--opacity-animated-reverse: " + (1 - scrollPercentage) + ";";
			let imageSizeVar = "--image-size: " + imageSize + "px;";
			let businessColorOverride = "";
			if(this.reservationsStore.selectedExperience && this.reservationsStore.selectedExperience.color) {
				let color = this.reservationsStore.selectedExperience.color;
				let textColor = isTextColorDark(color) ? "#000000" : "#FFFFFF";
				businessColorOverride = "--business-color: #" + color + ";";
				businessColorOverride += '--business-color-alpha20: #'+color+"32;";
				businessColorOverride += '--business-color-alpha40: #'+color+"64;";
				businessColorOverride += '--business-color-alpha60: #'+color+"96;";
				businessColorOverride += '--business-color-alpha80: #'+color+"CC;";
				businessColorOverride += '--business-text-color: '+textColor+';';
			}
			return themeBg1Animated + blurAnimated + boxShadowColor + opacityAnimated + opacityAnimatedReverse + imageSizeVar + businessColorOverride;
		},
		imageMenu() {
			if(this.menusStore.selectedMenu && this.menusStore.selectedMenu.picture) {
				return this.menusStore.selectedMenu.picture;
			}
			return this.menusStore.business.picture;
		},
		bannerPicture() {
			if(this.menusStore.business.picture) {
				return this.menusStore.business.picture;
			} else {
				let presetUrl = "https://img.qromo.io/img/presets";
				switch (this.menusStore.business.type) {
					case "restaurant":
						return presetUrl+"/new-preset-restaurant-1.jpg";
					case "events":
						return presetUrl+"/new-preset-bar-1.jpg";
					case "bar":
						return presetUrl+"/new-preset-bar-1.jpg";
					case "beach":
						return presetUrl+"/new-preset-beach-1.jpg";
					case "other":
						return presetUrl+"/new-preset-other-1.jpg";
				}
			}
		}
	},
	methods: {
		getPercentScroll() {
			if(this.currentScroll > this.maxScroll) return 1;
			if(this.currentScroll < this.minScroll) return 0;
			return (this.currentScroll - this.minScroll) / (this.maxScroll - this.minScroll);
		},
		alphaToHex(alpha) {
			let hex = Math.round(alpha * 255).toString(16);
			if(hex.length === 1) hex = "0" + hex;
			return hex;
		},
	},
	mounted() {
		setTimeout(() => {
			this.startAnimation = false;
		}, 500);
	},
	watch: {
	}
}
</script>

<style scoped lang="scss">
.menu-container {
	max-width: 1080px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	position: relative;
	width: calc((100% / 3) * 2);

	@media (max-width: 1024px) {
		width: 100%;
	}

	.menu-banner {
		height: var(--image-size);
		background-color: var(--theme-bg2-color);
		width: calc((100% / 3) * 2);
		max-width: 1080px;
		position: fixed;
		top: 0;
		right: calc((100% / 3));
		overflow: hidden;

		&.menuOnly {
			left: 0;
			right: 0;
			margin: 0 auto;
		}

		@media (max-width: 1024px) {
			width: 100%;
			right: 0;
		}

		img {
			object-fit: cover;
			transition: opacity 0.3s ease-in-out, transform 0.5s ease-in-out;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 1;

			&.hidden {
				display: none;
			}
			&.hiding {
				opacity: 0;
				transition: opacity 0.4s ease-in-out, transform 0.5s ease-in-out;
				transform: scale(1.05);
			}
			&.bigger {
				transform: scale(1.05);
			}
			&.opaque {
				display: block;
				opacity: 1;
			}
		}
	}

	.menu-container-scroll {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		z-index: 100;

		.menu-container-scroll-content {
			background-color: var(--theme-bg1-color);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			width: 100%;

		}

	}

}

</style>